import { render } from "./Search.vue?vue&type=template&id=8cc7bb3c"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=8cc7bb3c&lang=css"
script.render = render

export default script